/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface UpdateCardAccountUnitRequest
 */
export interface UpdateCardAccountUnitRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateCardAccountUnitRequest
     */
    'cardAccountUnit'?: UpdateCardAccountUnitRequestCardAccountUnitEnum;
}

export const UpdateCardAccountUnitRequestCardAccountUnitEnum = {
    all: 'ALL',
    group: 'GROUP',
    single: 'SINGLE'
} as const;

export type UpdateCardAccountUnitRequestCardAccountUnitEnum = typeof UpdateCardAccountUnitRequestCardAccountUnitEnum[keyof typeof UpdateCardAccountUnitRequestCardAccountUnitEnum];


